<div style="z-index: 10000 !important;">
  <div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <div>
      <img _ngcontent-dbj-c266="" src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" (click)="closeDialog()">
    </div>
  </div>
  @if (!companyActivated && !roleId && !companyActivatedData && !userId) {
    <div class="modal-body">
      Are you sure you want to perform this action ?
    </div>
  }
  @if (companyActivated || userId || roleId  || companyActivatedData) {
    <div class="modal-body">
      {{message}}
    </div>
  }

  @if (errorMsg) {
    <div class="text-danger text-center">
      {{ errorMsg }}
    </div>
  }
  <div class="modal-footer">
    <app-common-button buttonClass="smallbutton" [buttonLabel]="companyActivatedData ? 'ok' : 'Cancel'"
      (click)="closeDialog()">
    </app-common-button>
    @if (acceptRejectData) {
      <app-common-button buttonClass="smallFilledButton"
        buttonLabel="{{ acceptRejectData === 'Accept' ? 'Accept' : 'Reject' }}"
        (clickEvent)="confirmation(acceptRejectData)">
      </app-common-button>
    }
    @if (companyActivated) {
      <app-common-button buttonClass="smallFilledButton" [buttonLabel]="companyActivated"
        (clickEvent)="confirmation('isActivated')">
      </app-common-button>
    }
    <!-- roledeletion -->
    @if (roleId && !roleErrorMsg) {
      <app-common-button buttonClass="smallFilledButton" buttonLabel="Delete" (click)="deleteRole()"
        appAccessControl allowedRoles="role.delete">
      </app-common-button>
    }
    @if (roleErrorMsg) {
      <app-common-button buttonClass="smallFilledButton" buttonLabel="Ok" (click)="closePopup()">
      </app-common-button>
    }
    @if (userId) {
      <app-common-button buttonClass="smallFilledButton" [buttonLabel]="buttonLabel" (click)="deleteUser()"
        appAccessControl allowedRoles="user.disable">
      </app-common-button>
    }
  </div>
</div>